<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template #right><v-btn small rounded color="primary" :to="{ name: 'livestocks-edit', params: { lst_id: 0 } }">Ajouter un animal</v-btn></template>
        </PageHeader>
    
        <ItemForm v-if="( $route.params.lst_id !== undefined && parseInt( $route.params.lst_id ) >= 0 )"/>
        <v-card v-else class="ma-4 rounded-lg">
            <ItemsList />
        </v-card>
    
    </v-container>
    </template>
    
    <script>
    import PageHeader from '@/components/ui/PageHeader'
    import ItemsList  from '@/components/livestocks/LivestockList'
    import ItemForm   from '@/components/livestocks/LivestockForm'
    
    export default {
        name: 'livestocks-page',
        props: ['contextStyle'],
        components: {
            PageHeader,
            ItemsList, ItemForm
        },
        data: function () {
            return {
            }
        },
        computed: { },
        created(){},
        mounted: function (){
    
        },
        methods: {
    
        },
        beforeDestroy() {
    
        },
    }
    </script>